"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSearchResultQuery = void 0;
const React = require("react");
const react_instantsearch_1 = require("react-instantsearch");
const constants_1 = require("../../constants");
const app_1 = require("app");
const useSearchResultQuery = (initialQuery, setIsHitsAndFiltersLoading, setLastUserAction) => {
    const { query, refine: refineQuery, clear: clearQuery } = (0, react_instantsearch_1.useSearchBox)();
    React.useEffect(() => {
        const onSearchQueryChange = (event) => {
            const customEvent = event;
            setIsHitsAndFiltersLoading(true);
            refineQuery(customEvent.detail.query);
            setLastUserAction({ name: app_1.LastUserActionNameEnum.Query, value: customEvent.detail.query });
        };
        globalThis.addEventListener(constants_1.SEARCH_QUERY_CHANGE_EVENT, onSearchQueryChange);
        return () => {
            globalThis.removeEventListener(constants_1.SEARCH_QUERY_CHANGE_EVENT, onSearchQueryChange);
        };
    }, [initialQuery, setIsHitsAndFiltersLoading]);
    return { query, refineQuery, clearQuery };
};
exports.useSearchResultQuery = useSearchResultQuery;
